import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'administered-channels'

export type AdministeredChannelsType = string[]

export const administeredChannelsStorage =
  createKeyvalStorage<AdministeredChannelsType>(key)

export const administeredChannelsView =
  createKeyvalView<AdministeredChannelsType>(key)
